import React, { useEffect, useState } from "react";
import "./ViewGroup.scss";
import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../../TopBar/TopBar";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../Global/GlobalButton";
import { useNavigate } from "react-router-dom";
import {
  CreateButton,
} from "../../../../Global/GlobalButton";
import {
  GreenContent,
  RedContent,
} from "../../../../Global/GlobalText";
import { GlobalSecondTable } from "../../../../Global/GlobalSecondTable/GlobalSecondTable";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { MdEditSquare } from "react-icons/md";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { useSelector } from "react-redux";
import axios from "axios";
import { EXCHNAGE_URL, USER_EXCHNAGE_URL } from "../../../../../Url/Url";
import { toast } from "react-toastify";
import { round } from "lodash";

export const ViewGroup = () => {
  const navigate = useNavigate();
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const initialEventId = String(eventIdGet);
  const [selectedRows, setSelectedRows] = useState([]);
  const [roundData, setRoundData] = useState([])
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedRound, setSelectedRound] = useState(null);
  const [roundId, setRoundId] = useState(null);
  const [roundName, setRoundName] = useState("");
  const [groupData, setGroupData] = useState(null);
  const token = localStorage.getItem("token");



  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const eventId = initialEventId;
        console.log()
        const response = await axios.get(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const roundData = response.data.data;
        setRoundData(roundData);
        console.log(roundData)
      } catch (error) {
        console.log(error)
      }
    };
    fetchRounds();
  }, [])

  const handleRoundClick = (round) => {
    setSelectedRound(round);
    toast.success("Round selected Successfully")
    setRoundId(round.roundId); 
    setRoundName(round.round_name)

    setIsDropdownVisible(false);
  };
  const [allJudgeData, setAllJudgeData] = useState([]); // Add state for table data

  const fetchJuryGroup = async () => {
    try {
      if (roundId) {
        const response = await axios.get(
          `${EXCHNAGE_URL}/getaljudge?eventId=${initialEventId}&roundId=${roundId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const fetchedData = response.data.data;
        setAllJudgeData(fetchedData); // Store data in state
        console.log("Jury Group Data:", fetchedData);
      }
    } catch (error) {
      console.log("Error fetching Jury Group:", error);
      setAllJudgeData([]);
    }
  }

  useEffect(()=>{
    fetchJuryGroup()
  },[roundId , initialEventId, token])

  const handleCheckboxChange = (rowIndex, isChecked) => {
    setSelectedRows((prevSelected) => {
      console.log("Previous Selected Rows:", prevSelected);
      return isChecked
        ? [...prevSelected, rowIndex]
        : prevSelected.filter((index) => index !== rowIndex); 
    });
  };

  const setSelectedRow = (row) => {
    console.log("Selected row:", row); 
  };

  const heading = `Jury Group For ${roundName}`

  const columns = [
    { label: "Jury Group Name", accessor: "name" },
    { label: "Formula", accessor: "formula" },
    { label: "Actions", accessor: "actions" } // No renderCell needed here
  ];
  
  const data = allJudgeData.map((item) => ({
    rowId: item.juryGroupId,
    name: item.name,
    formula: item.formula || "",
    actions: (
      <>
        <MdEditSquare 
          style={{ color: "#0FA0F1", cursor: "pointer" }} 
          onClick={() => editGroupData(item.juryGroupId)}
        />
        <RiDeleteBin6Fill 
          style={{ color: "#C32728", cursor: "pointer" }} 
          onClick={() => handleDeleteJuryGroup(item.juryGroupId)}
                  />
      </>
    )
  }));

  const handleDeleteJuryGroup = async (juryGroupId) => {
    try {
      const response = await axios.delete(
        `${USER_EXCHNAGE_URL}/delete-group/${juryGroupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Jury group deleted:", response.data);
      toast.success("Jury group deleted successfully!");
      fetchJuryGroup(); // Refresh the list
    } catch (error) {
      console.error("Error deleting jury group:", error);
      toast.error("Failed to delete jury group.");
    }
  };
  
  const editGroupData = async (juryGroupId) => {
    try {
      const response = await axios.get(
        `${USER_EXCHNAGE_URL}/get-group/${juryGroupId}`,
        {
          headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const groupData = response.data;
        setGroupData(groupData);
        navigate("/create-jury-group", { 
          state: { 
            editData: groupData,
            roundId: roundId,
            roundName: roundName
          }
        });
      }
    } catch (error) {
      toast.error("Failed to fetch group data");
      console.error(error);
    } finally {
      // setLoader(false);
    }
  };
  

  return (
    <div>
      <div className="jury_existing_data_div">
        <TitleBar title="Jury Round" />
        <div className="jury_existing_data_white_bg">
          <TopBar titleheading={heading}/>
          <div className="newBtn">
            <div>
          <button
             className="Bt"
          onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
              {isDropdownVisible ? 'Hide Rounds' : 'Show Rounds'}
            </button>

            {isDropdownVisible && (
              <div
              className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}

              >
                {roundData.length !== 0 ? (
                  roundData.map((round, index) => (
                    <div
                      key={round.roundId}
                      className="round-button-container"
                      style={{ marginBottom: '1rem' }}
                    >
                      <CreateButton  className="Btt" onClick={() => handleRoundClick(round)}>
                        {round.round_name}
                      </CreateButton>
                       {round.is_active === 1 ? (
                              <GreenContent>Active</GreenContent>
                            ) : (
                              <RedContent>Unactive</RedContent>
                            )}
                    </div>
                  ))
                ) : (
                  <div>No rounds available</div>
                )}
              </div>
            )}
            </div>
          </div>

          <GlobalSecondTable
  data={data}
  columns={columns}
  selectedRows={selectedRows} 
  onCheckboxChange={handleCheckboxChange}
  onRowClick={setSelectedRow}
  disableSelection={true}
/>



          <div className="shortlist_butt">
            <GreyBorderButton
              onClick={() => {
                navigate("/jury-round");
              }}
            >
              Back to Jury Rounds
            </GreyBorderButton>

            <RedBackgroundButton
              onClick={() => {
                navigate("/jury-round");
              }}
            >
              Add New Jury Group
            </RedBackgroundButton>
          </div>


        
        
        </div>
      </div>
    </div>
  );
};
